<template>
  <div>
    <el-card class="box-card">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>充值</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>
    <div class="navbtn1">
        <el-card class="button-content">
          <!-- <el-button type="danger" size="small" @click="clearExpire" :loading="state">删除过期卡密</el-button> -->
          <el-button type="primary" size="small" class="icon-copy" v-clipboard:copy="shareLink" v-clipboard:success="onCopyLink" :loading="state"><i class="el-icon-share" style="margin-right:5px"></i>复制邀请链接</el-button>
        </el-card>
      </div>
    <div class="main-title">

      <el-card class="explain">
        <div class="float">
          <!-- <div style="margin-right: 10px">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-wallet"></use>
            </svg>
          </div> -->

          <div>
            <div style="font-size: 18px; margin-bottom: 5px">
              <!-- <span >余额</span> 
              <span class="action">
                <el-button type="primary" size="small" round @click="recharge">充  值</el-button>
              </span> -->
              <span class="action" >
                <el-button type="primary" size="small" round @click="tolink">点  我</el-button>
              </span>
            </div>
            <div style="font-size: 26px">{{ banlance }}</div>
          </div>
          
        </div>
        管理员QQ：58346871
        <!-- <div style="font-size:14px">
          <span><span style="color:red">新注册送7天试用期</span>，到期后系统会自动进行扣费，请在账户到期前保证账户余额充足，以免自动扣费失败导致账户被停用</span>
          <br>
          <span style="font-size:16px;margin-top: 10px; display: inline-block;">收费标准如下：</span>
          <br>
          <span style="color:red">按多开数量计费,未使用的卡密不计算数量</span>
          <br>
          <span>30元/月套餐，300张使用卡密，3000张未使用卡密</span>
          <br>
          <span>50元/月套餐，500张使用卡密，3000张未使用卡密</span>
          <br>
          <span>80元/月套餐，1000张使用卡密，3000张未使用卡密</span>
          <br>
          <span>120元/月套餐，1500张使用卡密，3000张未使用卡密</span>
          <br>
          <span>160元/月套餐，2000张使用卡密，3000张未使用卡密</span>
          <br>
          <span>200元/月套餐，2500张使用卡密，3000张未使用卡密</span>
          <br>
          <span>268元/月套餐，无限卡密</span>
          <br>
          <span style="color:red">* 卡密状态为【未使用】称为未使用卡密</span>
          <br>
          <span style="color:red">* 卡密数 = 卡密 x 多开上限</span>
          <br>
          <span style="color:red">* 单张卡密数 卡密多开上限100，则卡密数为100</span>
          <br>
          <span style="color:red">每人3000未激活卡密额度，超过的按10元/月3000未激活卡密计费</span>
        </div> -->
      </el-card>
    
      <el-card class="info" > 
        <el-table :data="tableData" style="width: 100%;" :show-header="false" border :cell-style="columnStyle">
          <el-table-column prop="date">
            
          </el-table-column>
          <el-table-column prop="name">
            <template slot-scope="scope">
              <span v-if="scope.row.name === '已到期'" style="color: #d80821;">已到期
                <el-button @click="reNewClick()" type="text" style="margin-left: 15px;">续 费</el-button>
              </span>
              <span v-if="scope.row.name === '正常'" style="color: #237804">{{scope.row.name}}
                <!-- <el-button @click="upgrade()" type="text" style="margin-left: 15px;">升级套餐</el-button> -->
              </span>
              <span v-if="scope.row.name === true || scope.row.name === false">
                <el-switch id="loginNum" @change='changeStatus' style="display: block" v-model="tableData[6].name" active-color="#13ce66" inactive-color="#d2d2d2" :loading="state"></el-switch>
              </span>
              <span v-if="scope.row.name !== '已到期' && scope.row.name !== '正常' && scope.row.name != true && scope.row.name != false">{{scope.row.name}}</span>
              <span v-if="scope.row.name === 0 || scope.row.name === 1">{{scope.row.name}}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </div>
     <!-- 充值表格 -->
    <el-card style="margin:0px 5px 5px 5px">
      <!-- <el-table :data="rechargeData" border style="width: 100%" v-loading="loading" stripe>
        <el-table-column prop="orderId" label="订单号"></el-table-column>
        <el-table-column prop="type" label="类型" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.type == '充值'" style="color: #237804">充值</span>
            <span v-if="scope.row.type == '推广'" style="color: #e9c710">推广</span>
            <span v-if="scope.row.type == '手动'" style="color: #2f5db1">手动</span>
            <span v-if="scope.row.type == '自动续费'" style="color: #e5212a">自动续费</span>
            <span v-if="scope.row.type == '手动续费'" style="color: #e5212a">手动续费</span>
            <span v-if="scope.row.type == '套餐升级'" style="color: #e59f21">套餐升级</span>
          </template>
        </el-table-column>
        <el-table-column prop="balance" label="金额" width="120"></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" width="170"></el-table-column>
      </el-table> -->
      <!-- 分页 -->
      <!-- <el-pagination
        @size-change="rechargeSizeChange"
        @current-change="rechargeCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination> -->
    </el-card>
    
    <!-- 升级套餐dialog -->
    <el-dialog title="升级套餐" :close-on-click-modal="false" :visible.sync="upgradeDialog" :width="diaLogWidth">
      <div style="margin-bottom: 10px;">
        <span style="font-size:16px">{{str}}</span>
      </div>
      <div style="margin-bottom: 10px;">
        <span style="font-size:16px">{{offsets}}</span>
      </div>
      <span style="font-size:16px">{{info}}</span>
      <br>
      <span style="color:red">*之前的套餐剩余时间会折合成余额抵消升级套餐金额</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="upgradeDialog = false" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="upgradeBtn" :loading="state">升级套餐</el-button>
      </span>
    </el-dialog>
    <!-- 充值dialog -->
    <el-dialog title="充值" :close-on-click-modal="false" :visible.sync="rechargeDialogVisible" :width="diaLogWidth">
      <el-form :model="payFrom" :rules="payFromRules" ref="payFromRef" label-width="auto" class="demo-ruleForm" size="small" >
        <el-form-item label="支付方式:" prop="pay_type" >
          <el-tag effect="plain">支付宝</el-tag>
        </el-form-item>
        <el-form-item label="充值金额:" prop="pay_price" >
          <el-input-number :precision="0" v-model="payFrom.pay_price" controls-position="right" :min="30" :max="2000"></el-input-number>
        </el-form-item>
          <el-form-item label="备注:" prop="remark" >
            <el-input type="textarea" :rows="1" placeholder="长度不超过128个字符" v-model="payFrom.remark"></el-input>
          </el-form-item>
      </el-form>
      <span style="color:red">*充值后不支持退款</span>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="rechargeDialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="payDialogVisibleShow">充 值</el-button>
      </span>
    </el-dialog>

    <!-- 二维码 -->
    <el-dialog title="请使用支付宝扫码" :close-on-click-modal="false" :visible.sync="payDialogVisible" :width="diaLogWidth" style="text-align:center" @close="close">
      <img :src="url" alt="支付宝二维码">
      <div style="font-size:24px;color:red">{{payFrom.pay_price}}元</div>
      <div>
        <span style="color:red">*请勿手动关闭当前页面</span>
        <span style="color:red">*充值成功该页面会自动关闭</span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      state: false,
      loading: true,
      rechargeData: [],
      total: 0,
      queryInfo: {
        query: "",
        //当前的页数
        pagenum: 1,
        //当前每页显示多少条数据
        pagesize: 10,
      },
      banlance: 0,
      tableData:[
        {
          date: "状态",
          name: ""
        },
        {
          date: "到期时间",
          name: ""
        },
        {
          date: "卡密数",
          name: ""
        },
        // {
        //   date: "费用",
        //   name: ""
        // },
        {
          date: "用量",
          name:""
        },
        {
          date: "远程数据+变量",
          name: ""
        },
        {
          date: "云函数",
          name: ""
        },
        // {
        //   date: "开启自动续费",
        //   name: true
        // },
        {
          date: "开启自动",
          name: true
        },
        {
          date: "未使用卡密数",
          name: ""
        },
        {
          date: "合计",
          name: ""
        },
      ],
      upgradeDialog: false,
      levelVip: 0,
      str: "",
      info: "",
      offsets: "",
      expire: 0,
      rechargeDialogVisible: false,
      payFrom:{
        pay_price: 30,
        remark: ""
      },
      payFromRules:{
        pay_price: [
          { required: true, message: "请输入充值金额最低30元", trigger: ["blur", "change"] },
        ]
      },
      diaLogWidth: "500px",
      payDialogVisible: false,
      url: "",
      intervalState: "",
      shareLink:"",
      shareId:"",
    };
  },
  created(){    
    this.getRechargeInfo(),
    this.getAuto()
    this.getRechargeList()
    this.$nextTick(()=>{
      if (document.body.clientWidth < 700){
        this.diaLogWidth = '100%'
      }
    })
  },
  methods:{
    onCopyLink(e) {
      this.$message.success('邀请注册链接已复制到剪贴板!')
    },
    /*
    async clearExpire(){
      this.state = true
      const result = await this.$http.post("clearexpire");
      // console.log('一键清理过期卡密result-->',result);
      this.state = false
      if(result.data.meta.status === 200){
        this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
        this.getRechargeInfo()
        this.getAuto()
        return
      }else{
        this.$notify.error({title: '错误', message:result.data.meta.msg});
        this.getRechargeInfo()
        this.getAuto()
        return
      }
    },
    */
    async getRechargeList(){
      this.state = true;
      const result = await this.$http.post("/getrechargelist", this.queryInfo);
      this.state = false;
      // console.log("获取充值列表result:",result);
      if(result.data.meta.status == 200){
        this.rechargeData = result.data.data.result.rechargeList.map(element => {
          if(element.createDate){
            element.createDate = this.timestampToTime(parseInt(element.createDate))
          }
          return element
        })
        this.total = result.data.data.result.total
      }
      this.loading = false
    },
    async getRechargeInfo(){
      const result = await this.$http.post("/getrechargeinfo");
      // console.log("result:",result);
      // console.log("result.data.data.shareId:",result.data.data.shareId);
      if(result.data.meta.status == 200){
        this.shareId = result.data.data.shareId
        window.sessionStorage.setItem('shareId',result.data.data.shareId)
        this.tableData[0].name = result.data.data.state
        this.tableData[1].name = this.timestampToTime(parseInt(result.data.data.expire))
        this.tableData[2].name = result.data.data.cardNum
        //this.tableData[3].name = result.data.data.price+"元"
        this.tableData[3].name = result.data.data.price
        this.tableData[4].name = result.data.data.remoteNum+"次"
        this.tableData[5].name = result.data.data.remoteFn+"次"
        this.tableData[7].name = result.data.data.cardNotUseNum//未使用卡密数量
        //this.tableData[8].name = result.data.data.totalPrice+"元"
        this.tableData[8].name = result.data.data.totalPrice
        this.levelVip = result.data.data.levelVip
        this.banlance = result.data.data.balance
        this.expire = result.data.data.expire
        this.shareLink = `http://developer.7ccccccc.com/register?ref=${this.shareId}`
      }
    },
    async reNewClick(){
      const result = await this.$http.post("/renewaccount");
      console.log("result:",result);
      if (result.data.meta.status == 200) {
        this.$notify.success({title: '成功',message: result.data.meta.msg});
        // this.getRechargeInfo()
        // this.getAuto()
        // this.getRechargeList()
        window.sessionStorage.removeItem("token");
        window.localStorage.removeItem("token");
        this.$router.push('/login')
      }else{
        this.$notify.warning({title: '失败', message:result.data.meta.msg});
        return
      }
    },
    upgrade(){
      this.upgradeDialog = true
      let day = Math.floor((this.expire - new Date().getTime()) / 86400000)
      let money = 0

      let remoteNumPrice = 0
      if(parseInt(this.tableData[4].name) > 500000){
        remoteNumPrice = Math.ceil(parseInt(this.tableData[4].name) / 500000) - 1
        console.log("remoteNumPrice:",remoteNumPrice);
      }
      if(this.levelVip == 0){
        this.str = "当前没有套餐,属于7天免费期"
        this.info = "确定要升级成30元套餐，300张可用卡密？7天免费试用期会结束"
      }else if(this.levelVip == 1){
        this.str = "当前30元套餐，300张可用卡密，已经使用了"+this.tableData[2].name+"张"
        this.info = "确定要升级成50元套餐，500张可用卡密"
        let needMoney = new this.$Decimal(50).sub(new this.$Decimal(day)).toNumber()
        needMoney = new this.$Decimal(needMoney).add(new this.$Decimal(remoteNumPrice)).toNumber()
        this.offsets = `还剩${day}天，可抵消${day}元，还需${needMoney}元`
      }else if(this.levelVip == 2){
        this.str = "当前50元套餐，500张可用卡密，已经使用了"+this.tableData[2].name+"张"
        this.info = "确定要升级成80元套餐，1000张可用卡密"
        money = new this.$Decimal(1.6).mul(new this.$Decimal(day)).toNumber()
        let needMoney = new this.$Decimal(80).sub(new this.$Decimal(money)).toNumber()
        needMoney = new this.$Decimal(needMoney).add(new this.$Decimal(remoteNumPrice)).toNumber()
        this.offsets = `还剩${day}天，可抵消${money}元，还需${needMoney}元`
      }else if(this.levelVip == 3){
        this.str = "当前80元套餐，1000张可用卡密，已经使用了"+this.tableData[2].name+"张"
        this.info = "确定要升级成120元套餐，1500张可用卡密"
        money = new this.$Decimal(2.6).mul(new this.$Decimal(day)).toNumber()
        let needMoney = new this.$Decimal(120).sub(new this.$Decimal(money)).toNumber()
        needMoney = new this.$Decimal(needMoney).add(new this.$Decimal(remoteNumPrice)).toNumber()
        this.offsets = `还剩${day}天，可抵消${money}元，还需${needMoney}元`
      }else if(this.levelVip == 4){
        this.str = "当前120元套餐，1500张可用卡密，已经使用了"+this.tableData[2].name+"张"
        this.info = "确定要升级成160元套餐，2000张可用卡密"
        money = new this.$Decimal(4).mul(new this.$Decimal(day)).toNumber()
        console.log("money:",money);
        let needMoney = new this.$Decimal(160).sub(new this.$Decimal(money)).toNumber()
        console.log("还需要:",needMoney);
        needMoney = new this.$Decimal(needMoney).add(new this.$Decimal(remoteNumPrice)).toNumber()
        this.offsets = `还剩${day}天，可抵消${money}元，还需${needMoney}元`
      }else if(this.levelVip == 5){
        this.str = "当前160元套餐，2000张可用卡密，已经使用了"+this.tableData[2].name+"张"
        this.info = "确定要升级成200元套餐，2500张可用卡密"
        money = new this.$Decimal(5.3).mul(new this.$Decimal(day)).toNumber()
        let needMoney = new this.$Decimal(200).sub(new this.$Decimal(money)).toNumber()
        needMoney = new this.$Decimal(needMoney).add(new this.$Decimal(remoteNumPrice)).toNumber()
        this.offsets = `还剩${day}天，可抵消${money}元，还需${needMoney}元`
      }else if(this.levelVip == 6){
        this.str = "当前200元套餐，2500张可用卡密，已经使用了"+this.tableData[2].name+"张"
        this.info = "确定要升级成268元套餐，无限卡密"
        money = new this.$Decimal(6.6).mul(new this.$Decimal(day)).toNumber()
        let needMoney = new this.$Decimal(268).sub(new this.$Decimal(money)).toNumber()
        needMoney = new this.$Decimal(needMoney).add(new this.$Decimal(remoteNumPrice)).toNumber()
        this.offsets = `还剩${day}天，可抵消${money}元，还需${needMoney}元`
      }else if(this.levelVip == 7){
        this.str = "当前268元套餐，无限卡密"
        this.info = "已经无限套餐，不可升级"
        this.offsets = ""
      }else if(this.levelVip == 99){
        this.str = "当前10元套餐，10张可用卡密，已经使用了"+this.tableData[2].name+"张"
        this.info = "确定要升级成30元套餐，300张可用卡密"
        money = new this.$Decimal(0.33).mul(new this.$Decimal(day)).toNumber()
        let needMoney = new this.$Decimal(30).sub(new this.$Decimal(money)).toNumber()
        needMoney = new this.$Decimal(needMoney).add(new this.$Decimal(remoteNumPrice)).toNumber()
        this.offsets = `还剩${day}天，可抵消${money}元，还需${needMoney}元`
      }
    },
    async upgradeBtn(){
      this.state = true
      const result = await this.$http.post("/upgrade");
      console.log("result:",result);
      if (result.data.meta.status == 200) {
        this.$notify.success({title: '成功',message: result.data.meta.msg});
        this.getRechargeInfo()
        this.getAuto()
        this.getRechargeList()
        this.upgradeDialog = false
      }else{
        this.$notify.warning({title: '失败', message:result.data.meta.msg});
      }
      this.state = false
    },
    async getAuto(){
      const result = await this.$http.post("/getauto");
      console.log("result:",result);
      if (result.data.meta.status == 200) {
        this.tableData[6].name = result.data.data.auto
      }
    },
    async changeStatus(){
      const result = await this.$http.post("/setauto", {auto:this.tableData[6].name});
      console.log("result:",result);
      if (result.data.meta.status == 200) {
        this.$notify.success({title: '成功',message: result.data.meta.msg});
        this.getAuto()
      }else{
        this.$notify.error({title: '失败',message:result.data.meta.msg});
      }
    },
    recharge(){
      this.rechargeDialogVisible = true
    },
    async payDialogVisibleShow(){
      let result = await this.$http.post("/recharge", this.payFrom)
      console.log("获取二维码result",result.data);
      if (result.data.meta.status === 200) {
        this.url = "https://xorpay.com/qr?data="+result.data.data.url.info.qr
        this.payDialogVisible = true
        // let iii = 0;
        this.intervalState = setInterval(async () => {
          // iii++;
          // if (iii >= 10) {
          //   clearInterval(this.intervalState)
          // }
          let res = await this.$http.post("/getorderstate", {order_id: result.data.data.order_id})
          console.log("查询订单状态：", res.data);
          if(res.data.meta.status == 200){
            if(res.data.data.status == "success"){
              //支付成功
              this.$notify.success({title: '成功',message: "支付成功"});
              this.getRechargeInfo()
              this.getAuto()
              this.getRechargeList()
              this.payDialogVisible = false;
              this.rechargeDialogVisible = false;
              clearInterval(this.intervalState)
            }else if(res.data.data.status == "expire"){
              this.$notify.error({title: '失败',message: "订单过期"});
              this.getRechargeInfo()
              this.getAuto()
              this.getRechargeList()
              this.payDialogVisible = false;
              this.rechargeDialogVisible = false;
              clearInterval(this.intervalState)
            }else if(res.data.data.status == "fee_error"){
              this.$notify.error({title: '失败',message: "手续费扣除失败"});
              this.getRechargeInfo()
              this.getAuto()
              this.getRechargeList()
              this.payDialogVisible = false;
              this.rechargeDialogVisible = false;
              clearInterval(this.intervalState)
            }else if(res.data.data.status == "payed"){
              this.$notify.success({title: '成功',message: "订单已支付-请联系管理员"});
              this.getRechargeInfo()
              this.getAuto()
              this.getRechargeList()
              this.payDialogVisible = false;
              this.rechargeDialogVisible = false;
              clearInterval(this.intervalState)
            }else if(res.data.data.status == "not_exist"){
              this.$notify.error({title: '失败',message: "订单不存在"});
              this.getRechargeInfo()
              this.getAuto()
              this.getRechargeList()
              this.payDialogVisible = false;
              this.rechargeDialogVisible = false;
              clearInterval(this.intervalState)
            }
          }
        },3000); 
        
      }else{
        this.$notify.error({title: '失败',message:result.data.meta.msg});
      }
    },
    close(){
      console.log("关闭二维码");
      clearInterval(this.intervalState)
      this.payDialogVisible = false;
      this.rechargeDialogVisible = false;
    },
    rechargeCurrentChange(val){
      this.queryInfo.pagenum = val
      this.getRechargeList()
    },
    rechargeSizeChange(val){
      this.queryInfo.pagesize = val
      this.getRechargeList()
    },
    // 自定义列背景色
    columnStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 0) {
        //第三第四列的背景色就改变了2和3都是列数的下标
        return "background:#f3f6fc;";
      }else{
        return "background:#ffffff;";
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 4 === 0) {
          return {
            rowspan: 4,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    timestampToTime(timestamp) {
      var date = new Date(timestamp);
      var year = date.getFullYear();
      var month = (date.getMonth() + 1 < 10 ? (date.getMonth() + 1) : date.getMonth() + 1);
      var day = date.getDate();
      var hours = date.getHours();
      var minute = date.getMinutes();
      var second = date.getSeconds();
      if (month < 10) { month = '0' + month }
      if (day < 10) { day = '0' + day }
      if (hours < 10) { hours = '0' + hours }
      if (minute < 10) { minute = '0' + minute }
      if (second < 10) { second = '0' + second }
      return year + '-' + month + '-' + day + ' ' + hours + ':' + minute + ':' + second;
    },
    changeInput(e){
      this.$forceUpdate()
    },
    tolink(){
      window.open(atob(atob("YUhSMGNEb3ZMekUxTkM0eE9UUXVNalV3TGpJeE1UbzNOemMz")), '_blank');
    }
  }
};
</script>

<style lang="less" scoped>
.el-pagination {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
}

.navbtn {
  margin-bottom: 20px;
}

.icon {
  width: 4em;
  height: 4em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
.main-title {
  .explain {
    margin: 5px;
    padding: 10px;
  }
  .info{
    padding: 10px;
    margin:5px;
  }
}

.float {
  display: flex;
  height: 64px;
  margin-bottom: 10px;
  position: relative;
  .action{
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 0;
  }
}


@media screen and (min-width: 1600px) and (max-width: 5000px) {
  .main-title {
    display: flex;
    .el-card {
      width: 50%;
      margin: 5px;
    }
  }
}

@media screen and (min-width: 576px) and (max-width: 1599px) {
  .main-title {
    display: flex;
    .el-card {
      width: 50%;
      margin: 5px;
    }
  }
}

@media screen and (max-width: 575px) {
  .el-card {
    // width: 100%;
    // margin: 5px;
  }
}
</style>